<template>
  <div class="home">
    <Header />
    <div class="home-nav">
      <ul class="home-nav-container">
      <li><a href="javascript:;" @click="goHref('/')">首页</a></li>
      <li><a href="javascript:;" @click="goHref('/classlist')">全部课程</a></li>
      <li><a href="javascript:;" @click="goHref('/company')">入驻机构</a></li>
      <li><a href="javascript:;" @click="goHref('/teacher')">合作讲师</a></li>
      <li><a href="javascript:;" @click="goHref('/come')">加盟入驻</a></li>
      <li><a href="javascript:;" @click="goHref('/examlist')">考试入口</a></li>
      <li><a href="javascript:;" @click="goHref('/book')">证书查询</a></li>
      </ul>
    </div>
    <div class="home-banner">
      <div class="home-banner-center">
        <img src="../assets/home/banner.png" alt="">
      </div>
      <div class="home-banner-container">
        <div class="home-banner-left">
          <div class="menutitle"><img src="../assets/icon/menu.svg" alt="">资源列表</div>
          <ul>
            <li v-for="(item, index) in menuList" :key="index">
              <h4>{{item.name}}<img src="../assets/icon/right-gray.svg"/></h4>
              <div class="p"><span v-for="(its,ins) in item.children" :key="ins+'000'">{{its.name}}&nbsp;&nbsp;</span></div>
              <div class="menufixed">
                <h5>{{item.name}}</h5>
                <div class="menufixed-container" v-for="(itst,inst) in item.children" :key="inst+'00000'">
                  <h6>{{itst.name}}</h6>
                  <span v-for="(value,inin) in itst.children" :key="inin+'0000000'" @click="goDetail(1)">{{value.name}}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="home-banner-right">
          <dl>
            <dt><img src="../assets/home/headimg.png" alt=""></dt>
            <dd>
              <span>欢迎来到宏云课堂</span>
              <p><a href="">学员登录</a> | <a href="">机构登录</a></p>
            </dd>
          </dl>
          <div class="line"><img src="../assets/home/xuline.png" alt="" width="228"></div>
          <div class="home-banner-control">
            <div class="home-banner-control-item"><img src="../assets/home/controlicon1.png" alt="" @click="goHref('/classList')">
              <p>我的课程</p>
            </div>
            <div class="home-banner-control-item"><img src="../assets/home/controlicon2.png" alt=""  @click="goHref('/car')">
              <p>购物车</p>
            </div>
            <div class="home-banner-control-item"><img src="../assets/home/controlicon3.png" alt=""  @click="goHref('/order')">
              <p>我的订单</p>
            </div>
            <div class="home-banner-control-item"><img src="../assets/home/controlicon4.png" alt="">
              <p>专属客服</p>
            </div>
            <div class="home-banner-control-item"><img src="../assets/home/controlicon5.png" alt="">
              <p>关注公众号</p>
            </div>
            <div class="home-banner-control-item"><img src="../assets/home/controlicon6.png" alt="">
              <p>下载APP</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-imagelist">
      <img src="../assets/home/imgbanner.png" alt="">
      <img src="../assets/home/imagebanner1.png" alt="">
      <img src="../assets/home/imagebanner2.png" alt="">
      <img src="../assets/home/imagebanner3.png" alt="">
      <img src="../assets/home/imagebanner4.png" alt="">
    </div>
    <div class="home-title">
      <h2>限时折扣<img src="../assets/home/hot.png" alt=""></h2>
    </div>
    <div class="home-list">
      <dl @click="goDetail(1)">
        <dt><img src="../assets/home/list1img.png" /></dt>
        <dd>
          <h5><span>采购</span>采购案例解析</h5>
          <p>讲师：吴小明 | 28课时</p>
          <div class="home-list-time">
            <div class="left">
              <img src="../assets/icon/time.svg" alt="">
              <span>距离结束：<i>09</i> 天 <i>12</i> 时</span>
            </div>
            <div class="right">
              <u>￥599</u>
              <b><i>￥</i>399</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl @click="goDetail(2)">
        <dt><img src="../assets/class/class2.png" /></dt>
        <dd>
          <h5><span>采购</span>国有企业招标采购专业实务及案例分析</h5>
          <p>讲师：袁静 | 20课时</p>
          <div class="home-list-time">
            <div class="left">
              <img src="../assets/icon/time.svg" alt="">
              <span>距离结束：<i>08</i> 天 <i>12</i> 时</span>
            </div>
            <div class="right">
              <u>￥599</u>
              <b><i>￥</i>499</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl @click="goDetail(4)">
        <dt><img src="../assets/home/list4.png" /></dt>
        <dd>
          <h5><span>采购</span>大数据技术对公共资源交易信息安全风险影响探析</h5>
          <p>讲师：汤骏 | 22课时</p>
          <div class="home-list-time">
            <div class="left">
              <img src="../assets/icon/time.svg" alt="">
              <span>距离结束：<i>07</i> 天 <i>12</i> 时</span>
            </div>
            <div class="right">
              <u>￥999</u>
              <b><i>￥</i>899</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl @click="goDetail(3)">
        <dt><img src="../assets/class/class11.png" /></dt>
        <dd>
          <h5><span>采购</span>施工标评审实务</h5>
          <p>讲师：何建新 | 18课时</p>
          <div class="home-list-time">
            <div class="left">
              <img src="../assets/icon/time.svg" alt="">
              <span>距离结束：<i>03</i> 天 <i>12</i> 时</span>
            </div>
            <div class="right">
              <u>￥1299</u>
              <b><i>￥</i>1099</b>
            </div>
          </div>
        </dd>
      </dl>
    </div>
    <div class="home-title">
      <h2>推荐课程</h2>
      <div class="more">更多</div>
    </div>
    <div class="home-list">
      <dl @click="goDetail(5)">
        <dt><img src="../assets/home/list5.png" /></dt>
        <dd>
          <h5><span>采购</span>公共资源交易</h5>
          <p>讲师：张志军 | 28课时</p>
          <div class="home-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>1699</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/class/class12.png" /></dt>
        <dd>
          <h5><span>采购</span>国有企业招标采购合法合规与非招标采购实务操作及热点问题风...</h5>
          <p>讲师：刘玲 | 11课时</p>
          <div class="home-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>328</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/class/class3.png" /></dt>
        <dd>
          <h5><span>采购</span>国有企业采购管理规范、招标采购操作实务及采购文件示范文本使...</h5>
          <p>讲师：刘一迪 | 13课时</p>
          <div class="home-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>736</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/class/class7.png" /></dt>
        <dd>
          <h5><span>采购</span>政府采购专职从业人员线上培训班</h5>
          <p>讲师：安帅 | 6课时</p>
          <div class="home-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>799</b>
            </div>
          </div>
        </dd>
      </dl>
    </div>
    <div class="home-list m25">
      <dl>
        <dt><img src="../assets/class/class4.png" /></dt>
        <dd>
          <h5><span>采购</span>【精品在线课程】招标采购基础能力提升</h5>
          <p>讲师：罗慧泰 | 12课时</p>
          <div class="home-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>899</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/class/class5.png" /></dt>
        <dd>
          <h5><span>采购</span>招标投标法律法规与实务操作、招标方案与招标文件编制要点与技巧</h5>
          <p>讲师：黄涛 | 5课时</p>
          <div class="home-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>1299</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/class/class6.png" /></dt>
        <dd>
          <h5><span>采购</span>招投标疑难法律问题与案例分析</h5>
          <p>讲师：冯先进 | 9课时</p>
          <div class="home-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>1808</b>
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt><img src="../assets/class/class8.png" /></dt>
        <dd>
          <h5><span>采购</span>政府采购从业人员沙龙课程</h5>
          <p>讲师：李立光 | 45课时</p>
          <div class="home-list-time">
            <div class="left">
              <img class="w18 h18" src="../assets/icon/fire.svg" alt="">
              <b>精品课</b>
            </div>
            <div class="right">
              <b><i>￥</i>1499</b>
            </div>
          </div>
        </dd>
      </dl>
    </div>
    <div class="home-imgbox">
      <img src="../assets/home/banner2.png" alt="">
    </div>
    <div class="home-title">
      <h2>本月热门</h2>
    </div>
    <div class="home-hot">
      <div class="home-hot-list">
        <div class="home-hot-title">
          <h4>月度热门机构<span>TOP5</span></h4>
          <b>INSTITUTIONS</b>
        </div>
        <ul>
          <li @click="goHref('/companyDetail')">
            <img src="../assets/icon/top1.png" alt="">
            <img src="../assets/home/companylist1.png" alt="">
            <p>光环国际教育集团</p>
          </li>
          <li @click="goHref('/companyDetail')">
            <img src="../assets/icon/top2.png" alt="">
            <img src="../assets/home/companylist2.png" alt="">
            <p>民生教育</p>
          </li>
          <li @click="goHref('/companyDetail')">
            <img src="../assets/icon/top3.png" alt="">
            <img src="../assets/home/companylist3.png" alt="">
            <p>京东科技</p>
          </li>
          <li @click="goHref('/companyDetail')">
            <b>04</b>
            <img src="../assets/home/companylist4.png" alt="">
            <p>国研智库有限公司</p>
          </li>
          <li @click="goHref('/companyDetail')">
            <b>05</b>
            <img src="../assets/home/companylist5.png" alt="">
            <p>珀金埃尔默</p>
          </li>
        </ul>
      </div>
      <div class="home-hot-list">
        <div class="home-hot-title">
          <h4>月度热门讲师<span>TOP5</span></h4>
          <b>POPULAR LECTURER</b>
        </div>
        <ul>
          <li>
            <b>01</b>
            <img src="../assets/teacher/teacher1.png" alt="">
            <p>吴小明<span>销量：188</span></p>
          </li>
          <li>
            <b>02</b>
            <img src="../assets/teacher/teacher2.png" alt="">
            <p>叶向阳<span>销量：152</span></p>
          </li>
          <li>
            <b>03</b>
            <img src="../assets/teacher/teacher3.png" alt="">
            <p>丁贵桥<span>销量：122</span></p>
          </li>
          <li>
            <b>04</b>
            <img src="../assets/teacher/teacher4.png" alt="">
            <p>汤骏<span>销量：112</span></p>
          </li>
          <li>
            <b>05</b>
            <img src="../assets/teacher/teacher5.png" alt="">
            <p>杜静<span>销量：112</span></p>
          </li>
        </ul>
      </div>
      <div class="home-hot-list">
        <div class="home-hot-title">
          <h4>月度热门课程<span>TOP5</span></h4>
          <b>POPULAR COURSES</b>
        </div>
        <ul>
          <li @click="goDetail(1)">
            <b>01</b>
            <p>采购案例解析<span>讲师：吴小明</span></p>
          </li>
          <li @click="goDetail(2)">
            <b>02</b>
            <p>国有企业招标采购专业实务及案例分析<span>讲师：袁静</span></p>
          </li>
          <li @click="goDetail(3)">
            <b>03</b>
            <p>施工标评审实务<span>讲师：何建新</span></p>
          </li>
          <li @click="goDetail(4)">
            <b>04</b>
            <p>大数据技术对公共资源交易信息安全风险影响探析<span>讲师：汤骏</span></p>
          </li>
          <li @click="goDetail(5)">
            <b>05</b>
            <p>公共资源交易<span>讲师：叶向阳</span></p>
          </li>
        </ul>
      </div>
    </div>
    <div class="home-title">
      <h2>合作讲师</h2>
      <div class="more" @click="goHref('/teacher')">更多</div>
    </div>
    <div class="home-teacher">
      <div class="home-teacher-swiper">
        <img src="../assets/home/teacher.png" alt="">
      </div>
      <div class="home-teacher-detail">
        <div class="home-teacher-title">
          <img src="../assets/teacher/teacher1.png" alt="">
          <p>
            <b>吴小明</b>
            <span>政府采购专家</span>
          </p>
        </div>
        <div class="home-teacher-container">曾作为中国代表团成员参加WTO政府采购协议谈判。中国政府采购研究所特聘专家，中国政府采购年鉴、中国政府采购网编委。出版个人专著《政府采购法律法规、实务操作与案例解析》，主编《政府采购基础知识》等10部专业书，发表文章数百篇。其独特的案例教学法获得广泛认可和好评。</div>
      </div>
      <div class="home-teacher-detail">
        <div class="home-teacher-title">
          <img src="../assets/teacher/teacher5.png" alt="">
          <p>
            <b>杜静</b>
            <span>中国招投标培训第一</span>
          </p>
        </div>
        <div class="home-teacher-container">是目前国内最早开始招投标培训的老师，也是唯一同时在招标培训和投标培训领域都拥有巨大的影响力的老师，拥有世界首创的实战控标课程《一击即中的投标技巧》和独创的实战模拟投标课程《夺标》。06年受邀于电视《前沿》讲座讲授《一击即中的投标技巧》课程，是北京大学、清华大学...</div>
      </div>
    </div>
    <div class="home-teacher mt20">
      <div class="home-teacher-detail">
        <div class="home-teacher-title">
          <img src="../assets/teacher/teacher2.png" alt="">
          <p>
            <b>叶向阳</b>
            <span>党组副书记</span>
          </p>
        </div>
        <div class="home-teacher-container">曾任宁波市政务服务办公室（公共资源交易管理办公室）党组副书记、副主任，二级巡视员，分管公共资源交易管理处、市招标投标监管中心，从事公共资源市场化配置改革工作多年，深研公共资源交易监督管理。</div>
      </div>
      <div class="home-teacher-detail">
        <div class="home-teacher-title">
          <img src="../assets/teacher/teacher3.png" alt="">
          <p>
            <b>丁贵桥</b>
            <span>经济学硕士</span>
          </p>
        </div>
        <div class="home-teacher-container">经济学硕士、高级经济师，曾任湖北省英山县副县长、湖北省乡镇企业建筑工程公司总经理、湖北省乡镇企业管理局副局长、湖北省随州市副市长、市委副书记、湖北省公共资源交易监督管理局局长、党组书记、湖北省政协常委。主要著作有：《乡镇企业经济学》...</div>
      </div>
      <div class="home-teacher-detail">
        <div class="home-teacher-title">
          <img src="../assets/teacher/teacher4.png" alt="">
          <p>
            <b>汤骏</b>
            <span>副主任</span>
          </p>
        </div>
        <div class="home-teacher-container">工学硕士，高级工程师，长期从事工程管理和招投标服务和信息化工作，在《中国标准化》、《中国管理信息化》、《招标采购管理》、《中国招标》、《公共采购》等期刊发表论文12篇。</div>
      </div>
      <div class="home-teacher-detail">
        <div class="home-teacher-title">
          <img src="../assets/teacher/teacher6.png" alt="">
          <p>
            <b>李德华</b>
            <span>副教授、硕士生导师</span>
          </p>
        </div>
        <div class="home-teacher-container">工程管理本科、经济法学硕士、民商法学博士（建设法方向）。任住建部执业资格注册中心特聘顾问、中国招标投标协会特聘顾问、中国建筑节能协会理事、最高人民检察院全国检察业务专家、天津市法学会理事、天津市政府法制（治）智库首届专家、天津仲裁委员会建设工程专委会首届召集人、仲裁员等职务。</div>
      </div>
    </div>
    <div class="home-title">
      <h2>合作机构</h2>
      <div class="more" @click="goHref('company')">更多</div>
    </div>
    <div class="home-imgbox m0">
      <img src="../assets/home/firend.png" alt="">
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import menuList from "@/assets/data/typeLeave.js";
import Footer from "@/components/Footer.vue";
import Fixed from "@/components/Fixed.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Fixed
  },
  data() {
    return {
      menuList,
      Footer,
    };
  },
  created() {
    console.log(menuList);
  },
  methods: {
    goHref(url) {
      this.$router.push(url)
    },
    goDetail(id) {
      this.$router.push(`/classDetails?id=${id}`)
    },
    goTop() {
      document.documentElement.scrollTop = 0
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  &-nav {
    width: 1300px;
    height: 22px;
    margin: 0 auto;
    padding: 9px 0 17px;
    text-align: right;
    &-container {
      display: inline-block;
      margin-right: 160px;
    }
    li {
      display: inline-block;
      margin-left: 72px;
      a {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
      }
    }
  }
  &-banner {
    &-container {
      background: #000;
      width: 1300px;
      margin: 0 auto;
      height: 0;
      display: flex;
      justify-content: space-between;
    }
    &-left {
      width: 232px;
      height: 368px;
      background: #ffffff;
      border-radius: 8px 8px 0px 0px;
      position: relative;
      top: -368px;
      .menutitle {
        height: 48px;
        background: #b6141a;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 48px;
        display: flex;
        align-items: center;
        border-radius: 8px 8px 0 0;
        img {
          width: 16px;
          height: auto;
          margin-left: 18px;
          margin-right: 8px;
        }
      }
      ul {
        position: relative;
        li {
          padding-left: 24px;
          cursor: pointer;
          h4 {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #202429;
            line-height: 22px;
            background: url(../assets/icon/right.svg) no-repeat 204px center;
            background-size: 16px 16px;
            padding: 20px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 12px;
            img {
              width: 16px;
              height: 16px;
            }
          }
          .p {
            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 20px;
              display: inline-block;
            }
          }
          &:first-child {
            h4 {
              padding-top: 12px;
            }
          }
          &:hover {
            .menufixed {
              display: block;
            }
          }
        }
      }
      .menufixed {
        display: none;
        width: 1000px;
        height: 368px;
        position: absolute;
        left: 232px;
        top: 0;
        background: #fff;
        z-index: 10;
        padding-left: 20px;
        h5 {
          font-size: 24px;
        }
        &-container {
          display: inline-block;
          vertical-align: top;
          width: 300px;
          margin-top: 20px;
          h6 {
            font-size: 14px;
          }
          span {
            color: #666666;
            font-size: 12px;
            display: inline-block;
            margin-right: 10px;
          }
        }
      }
    }
    &-center {
      width: 100%;
      height: 320px;
      position: relative;
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 1920px;
      }
    }
    &-right {
      position: relative;
      top: -309px;
      width: 260px;
      height: 300px;
      background: #ffffff;
      border-radius: 5px;
      border: 1px solid #eeeeee;
      .line {
        text-align: center;
        line-height: 1px;
      }
      dl {
        display: flex;
        width: 228px;
        margin: 0 auto;
        padding: 28px 0 14px;

        dt {
          img {
            width: 51px;
            height: auto;
          }
        }
        dd {
          margin-left: 20px;
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
          }
          p {
            color: rgba(151, 151, 151, 0.6);
            a {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #f57a27;
              line-height: 17px;
            }
          }
        }
      }
    }
    &-control {
      &-item {
        display: inline-block;
        width: 33.33%;
        text-align: center;
        img {
          width: 36px;
          height: 36px;
          margin-top: 30px;
        }
        p {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
          margin-top: 1px;
        }
      }
    }
  }
  &-imagelist {
    width: 1300px;
    margin: 11px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 252px;
      height: 69px;
    }
  }
  &-title {
    width: 1300px;
    margin: 47px auto 17px;
    display: flex;
    justify-content: space-between;
    h2 {
      font-size: 21px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 29px;
      display: inline-block;
      position: relative;
    }
    img {
      width: 34px;
      height: 17px;
      position: absolute;
      top: -2px;
      right: -40px;
    }
    .more {
      width: 98px;
      height: 36px;
      background: #F6F8FB;
      border-radius: 18px;    
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #000000;
      line-height: 36px; 
      text-align: center;
    }
  }
  &-list {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    dl {
      width: 310px;
      border-radius: 4px;
      dt {
        line-height: 0;
        img {
          width: 310px;
          height: 180px;
        }
      }
      dd {
        padding: 0 12px;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        margin-top: -1px;
        padding-top: 17px;
        border-radius: 0 0 4px 4px;
        h5 {
          font-size: 17px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 27px;
          height: 54px;
          text-overflow: -o-ellipsis-lastline;
	overflow: hidden;				//溢出内容隐藏
	text-overflow: ellipsis;		//文本溢出部分用省略号表示
	display: -webkit-box;			//特别显示模式
	-webkit-line-clamp: 2;			//行数
	line-clamp: 2;					
	-webkit-box-orient: vertical;	//盒子中内容竖直排列
          span {
            display: inline-block;
            width: 40px;
            height: 20px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
            background: #ff6154;
            border-radius: 2px;
            text-align: center;
            margin-right: 10px;
          }
        }
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 19px;
          margin-top: 8px;
        }
      }
    }
    &-time {
      padding-top: 18px;
      margin: 17px 0;
      border-top: 1px solid #eee;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        img {
          width: 15px;
          height: 15px;
        }
        span {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 19px;
          margin-left: 2px;
          i {
            font-style: normal;
            color: #ff8243;
          }
        }
        b {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 19px; 
        }
      }
      .right {
        u {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 19px;
          text-decoration: line-through;
          padding-right: 4px;
        }
        b {
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ff1d00;
          line-height: 24px;
          i {
            font-size: 15px;
            font-style: normal;
          }
        }
      }
    }
  }
  &-imgbox {
    text-align: center;
    margin-top: 56px;
    img {
      width: 1300px;
      height: auto;
    }
  }
  &-hot {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    &-list {
      width: 406px;
      height: 496px;
      background: linear-gradient(180deg, #FCF8ED 0%, #FEFBF5 14%, #FFFFFF 23%, #FFFFFF 100%);
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      ul {
        li {
          display: flex;
          align-items: center;
          padding-left: 22px;
          padding-bottom: 23px;
          b {
            font-size: 22px;
            font-family: Oswald-Bold, Oswald;
            font-weight: bold;
            color: #888;
            line-height: 34px;            
          }
          img:nth-child(1) {
            width: 27px;
            height: 33px;
          }
          img:nth-child(2) {
            height: 60px;
            width: auto;
            margin-left: 8px;
          }
          p {
            font-size: 13px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
            line-height: 23px;
            margin-left: 11px;
            span {
              display: block;
              font-size: 11px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #999999;
              line-height: 16px;
            }
          }
          &:nth-child(1) {
            b {
              color: #FA5055;
            }
          }
          &:nth-child(2) {
            b {
              color: #FF7130;
            }
          }
          &:nth-child(3) {
            b {
              color: #FFB425;
            }
          }
        }
      }
      &:nth-child(2) {
        li {
          padding-left: 27px;
          padding-bottom:20px;
          p {
            margin-left: 17px;
          }
          &:last-child {
            padding-bottom: 0;
          }
        }
      }
      &:nth-child(3) {
        li {
          padding-left: 27px;
          padding-bottom:41px;
          p {
            margin-left: 8px;
          }
          &:last-child {
            padding-bottom: 0;
          }
        }
      }
    }
    &-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 28px 36px 34px 27px;
      h4 {
        font-size: 16px;
        font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
        font-weight: 800;
        color: #D1802B;
        line-height: 24px;
        span {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #D1802B;
          line-height: 17px;
          margin-left: 7px;
        }
      }
      b {
        font-size: 16px;
        font-family: Helvetica-BoldOblique, Helvetica;
        font-weight: normal;
        color: #D1802B;
        line-height: 20px;
      }
    }
  }
  &-teacher {
    display: flex;
    justify-content: space-between;
    width: 1300px;
    margin: 0 auto;
    &-swiper {
      line-height: 0;
      img {
        width: 643px;
        height: auto;
      }
    }
    &-detail {
      width: 313px;
      height: 300px;
      background: #FFFFFF;
      border: 1px solid #EEEEEE;
      padding: 0 15px;
      box-sizing: border-box;
    }
    &-title {
      display: flex;
      align-items: center;
      padding-top: 36px;
      img {
        width: 90px;
        height: 90px;
        margin-right: 15px;
      }
      p {
        b {
          font-size: 19px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 26px;
        }
        span {
          display: block;
          width: 117px;
          height: 21px;
          background: #FFFFFF;
          border-radius: 2px;
          border: 1px solid #FF7E2F;
          text-align: center;
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #FF7E2F;
          line-height: 21px;
          margin-top: 10px;
        }
      }
    }
    &-container {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #A1A1A8;
      line-height: 23px; 
      margin-top: 30px;   
    }
  }
  &-fixed {
    border: 1px solid #EBEBEB;
    position: fixed;
    top: 50%;
    right: 100px;
    transform: translateY(-50%);
    &-item {
      border-top: 1px solid #EBEBEB;
      width: 60px;
      text-align: center;
      padding-top: 23px;
      padding-bottom: 23px;
      background: #fff;
      cursor: pointer;
      position: relative;
      img {
        &:nth-child(1) {
          width: 28px;
          height: 28px;
        }
        &:nth-child(2) {
          display: none;
          position: absolute;
          right: 60px;
          top: 0;
          border: 1px solid #eee;
          width: 136px;
          height: auto;
        }
      }
      &:first-child {
          border-top: 0;
        }
        &:hover {
          img:nth-child(2) {
            display: block;
          }
        }
    }
  }
}
.w18 {
  width: 18px !important;
}
.h18 {
  height: 18px !important;
}
.m25 {
  margin-top: 25px;
}
.mt20 {
  margin-top:20px;
}
.m0 {
  margin-top: 0px !important;
}
</style>
